export default "__VITE_ASSET__DzlgNLGj__"